import PropTypes from 'prop-types';

export const previewContentPropTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      icon: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ),
  alignment: PropTypes.oneOf([
    'topLeft',
    'bottomLeft',
    'topCenter',
    'bottomCenter',
    'topRight',
    'bottomRight',
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  coverContent: PropTypes.node,
  description: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    }),
  ),
  hasActions: PropTypes.bool,
  hasCover: PropTypes.bool,
  hasStatus: PropTypes.bool,
  statusClassName: PropTypes.string,
  statusIcon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  statusText: PropTypes.string,
  testId: PropTypes.string,
  title: PropTypes.string,
  trigger: PropTypes.shape({}),
};

export const contentPropTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  details: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string,
    }),
  ),
  className: PropTypes.string,
};

export const actionsPropTypes = {
  actions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      text: PropTypes.string,
      icon: PropTypes.string,
      onClick: PropTypes.func,
    }),
  ).isRequired,
  className: PropTypes.string,
};

export const statusPropTypes = {
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  text: PropTypes.string,
  className: PropTypes.string,
};

export const coverPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export const coverMediaPropTypes = {
  duration: PropTypes.number,
  type: PropTypes.oneOf(['course', 'live', 'topic', 'video', 'upnext']),
  image: PropTypes.string,
};

export const contentContainerPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export const contentTopContainerPropTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};
